const server = ''

let puertoCentury = process.env.REACT_APP_CENTURY
let puertoApp = process.env.REACT_APP_APP
let puertoMovimiento = process.env.REACT_APP_MOVIMIENTO
let puertoEquipo = process.env.REACT_APP_EQUIPO
let puertoMultimedia = process.env.REACT_APP_MULTIMEDIA
let puertoLazoLite = process.env.REACT_APP_LAZOLITE
let puerto_reporte_service = process.env.REACT_APP_REPORTE_SERVICE
let puertoAnalyzer = 9002
let puertoControlMaster = process.env.REACT_APP_CONTROL_MASTER
let host = process.env.REACT_APP_HOST as string
let host2 = process.env.REACT_APP_HOST2 as string
const puertpAppRumboWS = process.env.REACT_APP_RUMBO_WS
let HostPDF = process.env.REACT_APP_HOST as string
let hostMultimedia = process.env.REACT_APP_HOST_MULTIMEDIA as string
const hostMqtt = process.env.REACT_APP_HOST_MQTT
let puerto_integracion_sap = process.env.REACT_APP_INTEGRACION_SAP
const mqttUsername = process.env.REACT_APP_USER_MQTT
const mqttPassword = process.env.REACT_APP_PASS_MQTT
const mqttPort = process.env.REACT_APP_MQTT
let puertoSap = process.env.REACT_APP_SAP
const puertoMSfe = process.env.REACT_APP_MS_FE || 7012
const puertoClientMS = process.env.REACT_APP_CLIENT_MS||8716
const puertoIEGenexis = process.env.REACT_APP_IE_GENEXIS || 6969
const puertoUpgrateInvoice = process.env.REACT_APP_UPGRATE_INVOICE_PORT || 10010
const puertoMsClientesCredito = process.env.REACT_APP_MS_CLIENTES_CREDITO || 8719
const puertoGNVCloud = process.env.REACT_APP_GNV_CLOUD || 8721
const hostRabbit = process.env.REACT_APP_HOST_RABBIT as string
const puertoBroker = process.env.REACT_APP_BROKER
const responseOK = 200
const responseSucces = 201
const responseSesionCaducada = 205
const responseError = 400
const responseErrorServidor = 401
const versionApp = "3.0.0.1"
const versionCode = "3.0.0.1"
const aplicacion = process.env.REACT_APP_APPLICATION
const ntoken = 'Bearer '.concat(sessionStorage.getItem('token') + '')
const server_key = process.env.REACT_APP_KEY

function obtenerToken() {
  return 'Bearer '.concat(sessionStorage.getItem('token') + '')
}

export default {
  //hosts
  host,
  host2,
  hostMultimedia,
  HostPDF,
  //ports
  puertoApp,
  puertoSap,
  puerto_integracion_sap,
  puertoCentury,
  puertpAppRumboWS,
  puertoMovimiento,
  puertoEquipo,
  puertoMultimedia,
  puertoLazoLite,
  puerto_reporte_service,
  puertoAnalyzer,
  puertoControlMaster,
  puertoMSfe,
  puertoClientMS,
  puertoIEGenexis,
  puertoUpgrateInvoice,
    puertoMsClientesCredito,
    puertoGNVCloud,
    hostRabbit,
    puertoBroker,
    //keys
  server_key,
  ntoken,
  versionApp,
  versionCode,
  aplicacion,
  //response
  responseOK,
  responseSucces,
  responseError,
  responseSesionCaducada,
  responseErrorServidor,
  //mqtt
  hostMqtt,
  mqttUsername,
  mqttPassword,
  mqttPort,
  obtenerToken
}
